import { alpha, Box, styled } from '@ltvco/refresh-lib/theme';

const chipDimensions = {
  compact: { size: 36, fontSize: 20 },
  comfortable: { size: 48, fontSize: 24 },
} as const;

export type LegalIntelligenceIconChipSize = keyof typeof chipDimensions;

export const LegalIntelligenceIconChip = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$size',
})<{ $size?: LegalIntelligenceIconChipSize }>(
  ({ theme, $size = 'compact' }) => {
    const { size, fontSize } = chipDimensions[$size];
    return {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: size,
      height: size,
      borderRadius: '50%',
      flexShrink: 0,
      fontSize,
      backgroundColor: alpha(theme.palette.primary.main, 0.12),
      color: theme.palette.primary.main,
      ...($size === 'comfortable' ? { marginTop: theme.spacing(0.125) } : {}),
    };
  }
);
